<template>
	<a v-bind:href="item.Url"
			@click="eventClick(item)"
			v-bind:target="item.IsExternal ? '_blank' : '_self'" 
			class="card card-event card-event--item">
		<div class="card-content">
			<div class="card-content-title">
				<div class="card-event-featured" v-if="item.IsFeatured">Featured</div>
				<div class="card-content-title-wrap">
					<h3 v-if="item.EventName">{{ item.EventName }}</h3>
					<div v-html="formatAddress(item)"></div>
				</div>
			</div>

			<div class="cta-link" v-if="showctatext">
				{{ ctatext }}
			</div>
		</div>
	</a>
</template>

<script>
	import DateFormatService from '../../services/date-format.service';
	import analytics from '../../utils/analytics';

	export default {
		props: ['item', 'showctatext', 'ctatext'],
		components: {

		},
		mounted: function () {

		},
		methods: {
			formatDay(date) {
				return DateFormatService.formatDay(date);
			},
			formatMonth(date) {
				return DateFormatService.formatMonth(date);
			},
			formatDateRange(start, end) {
				return DateFormatService.formatDateRange(start, end);
            },
            formatAddress(item) {
				var address = [
					item.Address1,
					item.Address2,
					`${item.City}, ${item.State} ${item.Zipcode}`,
					item.Phone,
                    `<a href="mailto:${item.Email}${item.EmailSubjectBody}">${item.Email}</a>`
				];
				address = address.filter(x => x != null && x != '');
                return address.join('</br>');
            },
			eventClick(item) {
				let data = {
					full_event_name: item.Title,
					event_date: item.DateDisplay,
					event: item.EventName,
					location: `${item.City}, ${item.State}`
				};
				analytics.viewEventDetailsClick(data);
			}
        },
    }
</script>